export const TAX = "TAX"

export const FEE_INFO_ASSOCIATION_EDITOR = "Set the Platforms Commission for any payments taken by this Partner's Merchants. The Partner must set a percentage commission equal to or higher than the one specified here however the flat values can be below."

export const FEE_INFO_PARTNER_SETTINGS = "Set the Minimum Fees that Sales Staff can assign to Merchants. The Sales Staff must set a percentage commission equal to or higher than the one specified here however the flat values can be below."

export const FEE_INFO_COMPANY_DETAIL = "Set the fees that the merchant must pay for processing a transaction."

export const FEE_INFO_PACKAGE_DETAIL = "Set the fees that any merchant on this package must pay for processing a transaction."
